import { Box, Header as DefaultHeader } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const HeaderContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '$4',
  paddingX: '$4',
});

export const Header = DefaultHeader.withConfig({
  variant: 'headerThree',
  margin: 0,
  fontSize: '3xl',
  lineHeight: 'md',
});

export const SubText = withTypography({
  textAlign: 'center',
  fontSize: 'md',
  my: '$2',
  style: { fontWeight: 'normal' },
});
